<template>
  <div class="col-span-full flex justify-center flex-col items-center">
    <div class="flex justify-center flex-col max-w-[732px] rounded-[15px] border p-[48px_56px] bg-white border-[#E9E9E9]">
      <h1 class="font-neue-kabel font-thick text-[30px] leading-[134%] md:text-[44px] md:leading-[150%]">Välkommen till Gavlegårdarna!</h1>

    <div class="mt-4">
        <p class="font-normal text-[18px] leading-[147%]">
          Snart får du ett e-postmeddelande med information om hur du bekräftar din e-post.
          Följ länken för att fortsätta logga in på Mina sidor.
        </p>
        <div class="border-t border-[#E9E9E9] mt-6 pt-6">
          <h2 class="font-neue-kabel font-thick text-[18px] mb-1">
            Har du inte fått ett e-postmeddelande?
          </h2>

          <p class="font-normal text-[16px] leading-[154%]">
            Kontrollera att din e-postadress är korrekt och att vårt e-postmeddelande från noreply@gavlegardarna inte
            har hamnat i din skräppostmapp eller att din inkorg är full. Mailet kan ta några minuter att komma fram,
            hoppas du har tålamod med oss en stund.<br />
            Om det inte hjälper är du varmt välkommen att <a href="/kontakt">Kontakta oss</a>
          </p>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as config from '@/config';

export default {
  name: 'RegistrationInformation',
  data () {
    return{
      showPolicy: false,
      apiUrl: config.API_BASEURL_V2
    }
  },
  computed: {
    ...mapGetters({
      webapp_config : 'webapp_config',
    })
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.welcome-image {
  width: 120px;
  margin: 1em 0;
}

.btnRow {
  margin-top: 2em;
}

.confirmation {
  &__icon {
    display: flex;
    margin: 24px auto 16px;
    width: 30px;
    height: 30px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      display: block;
      background-image: url("https://tstabgmypagescode.blob.core.windows.net/public/drop/static/images/Email.svg");
      width: 30px;
      height: 30px;
      z-index: 5;
    }

    &:before {
      content: "";
      position: absolute;
      display: block;
      left: -9px;
      top: -9px;
      width: 48px;
      height: 48px;
      background-color: #FFD000;
      border-radius: 50%;
      z-index: 1;
    }
  }
}

.disclaimer {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E9E9E9;

  h2 {
    font-size: 1.6rem;
    text-align: left;
  }

  p {
    font-size: 1.4rem;
    line-height: 1.5;

    &:not(:last-of-type) {
      margin-bottom: 16px;
    }
  }
}
</style>
